import { render, staticRenderFns } from "./dingbu.vue?vue&type=template&id=3b838818&scoped=true&"
import script from "./dingbu.vue?vue&type=script&lang=js&"
export * from "./dingbu.vue?vue&type=script&lang=js&"
import style0 from "./dingbu.vue?vue&type=style&index=0&id=3b838818&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b838818",
  null
  
)

export default component.exports